import React, { CSSProperties } from 'react';
import { Box } from '@osmosis/react-ui/components/Box';
import { Flex } from '@osmosis/react-ui/components/Box';
import moWaving from '../../assets/mo-waving.webp';
import { FormattedMessage } from 'react-intl';

type Props = {
  containerStyle?: CSSProperties;
};

/**
 * This component is used to display the header for the Elsevier sign in experience
 * and is shown on lockout modals.
 */
const ElsevierSignInExperienceHeader = (props: Props) => {
  const { containerStyle: { backgroundColor = 'bg-gray-100' } = {} } = props;
  return (
    <Box>
      <Flex
        className={`py-[24px] px-2 items-center rounded-t-lg ${backgroundColor}`}
      >
        <Box className={`pl-1 pr-4`}>
          {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
          <img
            src={moWaving.src}
            /* eslint-disable-next-line formatjs/no-literal-string-in-jsx */
            alt="Mo waving"
            className="px-w w-[71px] h-[55px]"
          />
        </Box>
        <Flex className={`flex-col`}>
          <Box
            style={{ fontFamily: 'Elsevier Sans' }}
            className={`font-bold text-[20px] sm:text-[20px] mb-1 font-`}
          >
            <FormattedMessage
              id="learn.elsevier_sign_in_experience_header.transitioning"
              defaultMessage="We have transitioned to a new sign-in experience"
            />
          </Box>
          <Box
            style={{ fontFamily: 'Elsevier Sans' }}
            className={`text-[16px] sm:text-[16px]`}
          >
            <FormattedMessage
              id="learn.elsevier_sign_in_experience_header.experience"
              defaultMessage="You will see a new Elsevier sign-in experience in the next screen."
            />
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};

export default ElsevierSignInExperienceHeader;
